import './Style.scss';
import { DataPoint } from 'Interfaces/DataPoint';
import { ListItem } from 'Interfaces/Forms/QuestionInterface';
import * as React from 'react';
import FormUtils from 'views/SingleInstance/utils/FormUtils';
import { useDroppable } from '@dnd-kit/react';
import TaskCard from '../TaskCard';

interface Props {
  status: ListItem;
  index: number;
  i: number;
  dataPoints: DataPoint[];
  extraFields: string[];
  severityListItem: ListItem[];
  formUtils: FormUtils;
  showMultiViewer: (dp: DataPoint) => void;
}
export default function StatusColumn(props: Props) {
  const { status, index, dataPoints, severityListItem, extraFields, formUtils } = props;
  const {ref, isDropTarget} = useDroppable({
    id: `kanban-${status.id}-${index}`,
    accept: (source) => source.data.status && source.data.status !== status.id
  });

  return (
    <div
      ref={ref}
      className={`col droppable ${ isDropTarget ? 'drop-active' : ''}`}
    >
      {dataPoints.map((dataPoint, i) => (
        <TaskCard
          key={`kboard-${status.value}-${index}-${i}`}
          status={status}
          dataPoint={dataPoint}
          severityListItem={severityListItem}
          extraFields={extraFields}
          formUtils={formUtils}
          showMultiViewer={(dp) => props.showMultiViewer(dp)}
        />
      ))}
    </div>
  );
}
